// extracted by mini-css-extract-plugin
export default {"slider":"SliderPartners_slider__G56ff"};